import { Component } from '@angular/core';
import { IonicPage, NavController, ToastController, MenuController, LoadingController, Platform } from 'ionic-angular';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { AuthenticationApi } from '../../services/authentication/authentication-api';
import { ScannerPage } from '../scanner/scanner';
import { NewAccountPage } from '../new-account/new-account';
import { ForgotPasswordPage } from '../forgot-password/forgot-password';

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
  public loginForm: FormGroup;
  public username: FormControl;
  public password: FormControl;

  ionViewCanEnter() {
    let self: LoginPage = this;
    return new Promise((resolve, reject) => {
      if(self.authApi.isAuthenticated()) {
        this.navCtrl.setRoot(ScannerPage);
        resolve(null);
      }

      else {
        self.storage.getItem("login-email")
          .subscribe(res => {
            self.username.setValue(res);
            resolve(null);
          },
          rej => {
            resolve(null);
          });
      }
    });
  }

  login(value) {
    let self: LoginPage = this;
    this.storage.removeItem("reset-password-email")
      .subscribe(() => {self.logingIn(self.authApi.login(value));})
  }

  forgot() {
    this.navCtrl.push(ForgotPasswordPage)
  }

  private logingIn(observable) {
    let self: LoginPage = this;

    let loading = this.loadingCtrl.create({
      content: "Logging In..."
    });

    loading.present();

    observable.subscribe(
      () => {
        this.storage.removeItem("login-email")
          .subscribe(() => {
            self.authApi.profile().subscribe(Profile => {
              let menus: Array<string> = ["sys-admin","admin","staff"];
              let menu: string = menus.splice(menus.indexOf(String(Profile.get("roles")[0].name).toLowerCase()),1)[0];

              // enable menu.
              self.menuCtrl.enable(true, menu);

              // disable menu.
              menus.map(function(m){ self.menuCtrl.enable(false,m); });

              // shut off loader.
              loading.dismiss();

              // go to scanner.
              self.navCtrl.setRoot(this.platform.is("Cordova") ? ScannerPage : NewAccountPage);

            },
            rej => {
              // shut off loader.
              loading.dismiss();

              let toast = self.toastCtrl.create({ message: "Your user account could not be loaded.  Please try again.  Contact support if the symptom persists.", duration: 9000, position: "top", dismissOnPageChange: true});
              toast.present();
            });
          })
      },
      rej => {
        // shut off loader.
        loading.dismiss();

        let toast = self.toastCtrl.create({ message: rej.message, duration: 9000, position: "top", dismissOnPageChange: true});
        toast.present();
      }
    );
  }

  constructor( public navCtrl: NavController,
    private fb: FormBuilder,
    private authApi: AuthenticationApi,
    private storage: AsyncLocalStorage,
    private menuCtrl: MenuController,
    private loadingCtrl: LoadingController,
    private platform: Platform,
    private toastCtrl: ToastController) {

    this.username = this.fb.control('', Validators.compose([Validators.required]));
    this.password = this.fb.control('', Validators.compose([Validators.required]));

    this.loginForm = this.fb.group({
      username: this.username,
      password: this.password
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts